"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var Tabs_1 = __importDefault(require("../Tabs"));
var Methods_1 = __importDefault(require("./Methods"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var bank_transfer_1 = require("../icons/bank-transfer");
var cards_1 = require("../icons/cards");
var crypto_1 = require("../icons/crypto");
var Header_1 = __importDefault(require("./Header"));
var WithdrawalUnavailableDisclaimer_1 = __importDefault(require("./WithdrawalUnavailableDisclaimer"));
var Withdrawal = function (_a) {
    var _b;
    var methods = _a.methods, _c = _a.footerInsideInfo, footerInsideInfo = _c === void 0 ? false : _c;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _d = (0, react_1.useState)('banking-card'), method = _d[0], setMethod = _d[1];
    var _e = (0, swr_hooks_1.useAvailableWithdrawalBalance)(), data = _e.data, isLoading = _e.isLoading;
    var userBalance = (0, swr_hooks_1.useBalance)().data;
    var METHODS_FILTERS = (0, react_1.useMemo)(function () { return ({
        'banking-card': {
            label: t('cards'),
            Icon: cards_1.CardsIcon,
            stroke: true,
            key: 'banking-card',
        },
        'crypto-currency': {
            label: t('crypto'),
            Icon: crypto_1.CryptoIcon,
            stroke: true,
            key: 'crypto-currency',
        },
        'bank-transfer': {
            label: t('bankTransfers'),
            Icon: bank_transfer_1.BankTransferIcon,
            stroke: true,
            key: 'bank-transfer',
        },
    }); }, [t]);
    var currentCurrency = ((_b = data === null || data === void 0 ? void 0 : data.balance) === null || _b === void 0 ? void 0 : _b.currency) || 'EUR';
    var methodsWithLabels = Object.entries(METHODS_FILTERS).map(function (_a) {
        var methodName = _a[0], methodValues = _a[1];
        return (__assign(__assign({}, methodValues), methods.find(function (m) { return m.name === methodName; })));
    });
    var currentMethod = (0, react_1.useMemo)(function () {
        return methodsWithLabels.find(function (f) { return f.name === method; });
    }, [methodsWithLabels, method]);
    var currencySettings = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = currentMethod === null || currentMethod === void 0 ? void 0 : currentMethod.currencies) === null || _a === void 0 ? void 0 : _a.find(function (currency) { return currency.name === currentCurrency; });
    }, [method, currentCurrency]);
    var realBalance = (0, react_1.useMemo)(function () { return +((userBalance === null || userBalance === void 0 ? void 0 : userBalance.amount) || 0); }, [userBalance]);
    var bonusBalance = (0, react_1.useMemo)(function () {
        return (Number(userBalance === null || userBalance === void 0 ? void 0 : userBalance.totalAmount) || 0) -
            (Number(userBalance === null || userBalance === void 0 ? void 0 : userBalance.amount) || 0);
    }, [userBalance]);
    var withdrawalBalance = (0, react_1.useMemo)(function () { var _a; return +(((_a = data === null || data === void 0 ? void 0 : data.balance) === null || _a === void 0 ? void 0 : _a.amount) || 0); }, [data]);
    var min = (0, react_1.useMemo)(function () { return +((currencySettings === null || currencySettings === void 0 ? void 0 : currencySettings.min) || 0); }, [currencySettings]);
    var _f = (0, react_1.useState)(false), mounted = _f[0], setMounted = _f[1];
    (0, react_1.useEffect)(function () {
        setMounted(true);
        return function () { return setMounted(false); };
    }, []);
    if (!(methods === null || methods === void 0 ? void 0 : methods.length) || isLoading || !mounted)
        return react_1.default.createElement("div", { className: styles_module_scss_1.default.loading },
            t('loading'),
            "...");
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(Header_1.default, null),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.main },
                react_1.default.createElement(Tabs_1.default, { methods: methodsWithLabels, method: method, setMethod: setMethod }),
                data &&
                    data.canWithdraw &&
                    min > withdrawalBalance &&
                    min > realBalance && (react_1.default.createElement(WithdrawalUnavailableDisclaimer_1.default, { text: t('unavailableWithdrawalsMinAmount') })),
                bonusBalance > 0 && (react_1.default.createElement(WithdrawalUnavailableDisclaimer_1.default, { text: t('unavailableWithdrawalsWhileBonusBalanceActive') })),
                !bonusBalance && min > withdrawalBalance && realBalance >= min && (react_1.default.createElement(WithdrawalUnavailableDisclaimer_1.default, { text: t.raw('unavailableWithdrawalsWagerActive') })),
                react_1.default.createElement(Methods_1.default, { canWithdraw: data === null || data === void 0 ? void 0 : data.canWithdraw, balance: data === null || data === void 0 ? void 0 : data.balance, method: currentMethod, footerInsideInfo: footerInsideInfo })))));
};
exports.default = Withdrawal;
